import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './style.module.scss';

const BackToDashboard = () => {
  const history = useHistory();
  return (
    <img
      onClick={() => {
        history.push('/dashboard');
      }}
      className={`mr-4 ${styles.goBackArrow}`}
      src="/images/arrow.svg"
    />
  );
};

export default BackToDashboard;
